export default "__VITE_ASSET__DQPxcmNo__"